const styles = theme => ({
  popper:{
    zIndex:3000
  },
  iconUserMenu:{
    color: theme.palette.primary.main,
  },
});

export default styles;
